import cn from 'classnames';
import { PrismicRichText } from '@components/PrismicRichText';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapTitleAndIntro } from './mapTitleAndIntro';
import { ITitleAndIntro } from './types';
import { PrismicTitle } from '@components/PrismicTitle';

const TitleAndIntro = ({
  title,
  titleStyle,
  introduction,
  contentAlignment,
}: ITitleAndIntro) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-gap-4',
        contentAlignment && 'tw-text-center',
      )}
    >
      {title && <PrismicTitle field={title} titleStyleField={titleStyle} />}
      {introduction && introduction.length > 0 && (
        <div
          className={cn('tw-max-w-[790px]', contentAlignment && 'tw-mx-auto')}
        >
          <PrismicRichText field={introduction} />
        </div>
      )}
    </div>
  );
};

export default withSlice(TitleAndIntro, mapTitleAndIntro);
